class ProductHotspotsDrawer extends Drawer {
  constructor() {
    super();

    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      document.querySelector('mobile-menu').mobilemenuHide();

      if (!this.isMobile) document.body.classList.add('drawer--isActive');

      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : this.firstElementChild;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    const index = triggeredBy?.dataset?.index || 0;

    publish(PUB_SUB_EVENTS.selectSlide, index);

    if (!this.isMobile) document.body.classList.add('overflow-hidden');
  }

  close() {
    super.close();

    publish(PUB_SUB_EVENTS.drawerClosed);
  }
}

if (!customElements.get('product-hotspots-drawer')) {
  customElements.define('product-hotspots-drawer', ProductHotspotsDrawer);
}
